import React from 'react';
import { ContentSection } from '~/components';
import { ImageBlock, H2Title } from '~/containers/styles';
import Loading from '~/../img/loading-opacity.gif';

export default ({ title = '' }) => (
  <ContentSection>
    <div className="row">
      <div className="col-xs-12 text-center" style={{ padding: '50px 0' }}>
        <H2Title>{`กำลังเตรียมข้อมูล${title && `: ${title}`}`}</H2Title>
        <ImageBlock src={Loading} />
      </div>
    </div>
  </ContentSection>
);



// WEBPACK FOOTER //
// ./resources/assets/js/components/LoadingPage/index.js